import { Badge } from "@/components/ui/badge";
import { providerName } from "./providerHelpers";

/** Small label saying which company makes a model; nothing when we don't know. */
const ProviderChip = ({ provider }: { provider: unknown }) => {
  const name = providerName(provider);
  return name ? <Badge variant="outline">{name}</Badge> : null;
};

export default ProviderChip;
